import type { GameKindAdapter } from "../shared/adapter";
import { compileGridStrategy } from "./compiler";
import { evaluateGridStrategy } from "./evaluator";
import { repairCommandsForGridStrategy } from "./repair";
import { parseGridStrategySpec, type GridStrategySpec } from "./spec";

export const gridStrategyAdapter: GameKindAdapter = {
  kind: "grid-strategy",
  briefHints: ["territory", "board capture", "claim the most squares", "conquer the grid", "tile control", "board game with my friend"],
  promptSchemaLine: '{"kind":"grid-strategy","params":{"cols":integer 4-8,"rows":integer 4-8,"players":1 or 2 (2 = local hot-seat versus a friend, mirror-fair corners)}}',
  parseSpec: parseGridStrategySpec,
  compile: (spec) => compileGridStrategy(spec as GridStrategySpec),
  evaluate: (spec) => evaluateGridStrategy(spec as GridStrategySpec),
  repairCommandsFor: (spec, failedReceipt) => repairCommandsForGridStrategy(spec as GridStrategySpec, failedReceipt),
};

export type { GridStrategySpec } from "./spec";
